export default __webpack_public_path__ + "static/media/banner-2.d6893d06.jpg";